import {Component, DestroyRef, inject} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {FormsModule} from '@angular/forms';
import {finalize} from 'rxjs';
import {NZ_MODAL_DATA, NzModalRef} from 'ng-zorro-antd/modal';
import {NzSelectModule} from 'ng-zorro-antd/select';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {AuthFlowService} from '../../../core/services/auth-flow.service';
import {AppRole} from '../../../core/models/app-role';

export interface SetRolesModalData {
  userId: string;
  username: string;
  roles: string[];
}

@Component({
  selector: 'app-set-roles-modal',
  imports: [
    TranslatePipe,
    FormsModule,
    NzSelectModule,
  ],
  templateUrl: './set-roles-modal.html',
  styleUrl: './set-roles-modal.css',
})
export class SetRolesModal {
  private readonly translate = inject(TranslateService);
  private readonly _data = inject<SetRolesModalData>(NZ_MODAL_DATA);
  private readonly _modalRef = inject(NzModalRef);
  private readonly _authFlow = inject(AuthFlowService);
  private readonly _notification = inject(NzNotificationService);
  private readonly _destroyRef = inject(DestroyRef);

  readonly username = this._data.username;

  readonly availableRoles = [
    {name: AppRole.Admin, labelKey: 'adminUsers.roleAdmin'},
  ];

  selectedRoles: string[] = this.availableRoles
    .filter(role => this._data.roles.includes(role.name))
    .map(role => role.name);

  handleOk(): void {
    this._modalRef.updateConfig({nzOkLoading: true, nzCancelDisabled: true});

    this._authFlow.setManagedUserRoles(this._data.userId, this.selectedRoles)
      .pipe(finalize(() => this._modalRef.updateConfig({nzOkLoading: false})), takeUntilDestroyed(this._destroyRef))
      .subscribe({
        next: () => {
          this._modalRef.close(true);
          this._notification.success(
            this.translate.instant('common.success'),
            this.translate.instant('adminUsers.rolesChanged'));
        },
        error: () => {
          this._modalRef.updateConfig({nzCancelDisabled: false});
        }
      });
  }
}
